var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicySubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "525.047px",
    height: "525.047px",
    viewBox: "0 0 525.047 525.047",
    style: {
      enableBackground: "new 0 0 525.047 525.047"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M443.721,293.566l23.389,23.383h-66.762c-23.365,0-34.72-13.062-49.101-29.601c-7.17-8.24-15.173-17.39-25.352-24.87 c10.179-7.482,18.193-16.633,25.352-24.872c14.381-16.535,25.735-29.602,49.101-29.602h66.851l-23.478,23.472l21.396,21.397 l59.93-59.918l-59.93-59.914l-21.396,21.397l23.312,23.309h-66.685c-37.155,0-56.448,22.183-71.946,40.001 c-14.381,16.535-25.735,29.604-49.106,29.604h-70.583c-8.642-49.367-51.713-87.036-103.518-87.036 C47.191,160.317,0,207.503,0,265.511c0,58.012,47.191,105.191,105.194,105.191c53.906,0,98.417-40.767,104.446-93.083h69.655 c23.365,0,34.72,13.057,49.101,29.602c15.504,17.814,34.791,40.004,71.952,40.004h66.756l-23.383,23.383l21.396,21.397 l59.924-59.912l-59.924-59.924L443.721,293.566z M105.2,331.384c-36.328,0-65.881-29.542-65.881-65.879 c0-36.333,29.554-65.884,65.881-65.884s65.884,29.551,65.884,65.884C171.084,301.842,141.527,331.384,105.2,331.384z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicySubject);
export default __webpack_public_path__ + "static/media/policy-subject.a9ddbb16a299232defb65dceb00d5239.svg";
export { ForwardRef as ReactComponent };